import { Repository } from '@/repository/repository'

const api = Repository.call('sfp')

const SET_ME = 'SET_SFP_ME'
const SET_READ_ONLY = 'SET_SFP_READ_ONLY'

const state = {
  me: null,
  readOnly: false
}

const getters = {
  me: state => state.me,
  readOnly: state => state.readOnly
}

const actions = {
  async loadMe ({ commit }) {
    const response = await api.me()
    commit(SET_ME, response.level ? response.data : null)
    return response
  },
  resetReadOnly ({ commit }) {
    commit(SET_READ_ONLY, false)
  },
  listOrders (_, params) {
    return api.listOrders(params)
  },
  getOrder (_, id) {
    return api.getOrder(id)
  },
  exportOrders (_, params) {
    return api.exportOrders(params)
  }
}

const mutations = {
  [SET_ME] (state, me) {
    state.me = me
  },
  [SET_READ_ONLY] (state, readOnly) {
    state.readOnly = readOnly
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/sfp.js